import React, { useMemo } from 'react';
import countryList from 'react-select-country-list';

interface CountrySelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  required?: boolean;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onChange,
  disabled = false,
  required = false,
  className = 'auth-select' // Default class
}) => {
  const countries = useMemo(() => countryList().getData(), []);

  return (
    <select
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      required={required}
    >
      <option value="" disabled>Select Country</option>
      {countries.map((c: { value: string; label: string }) => (
        <option key={c.value} value={c.value}>
          {c.label}
        </option>
      ))}
    </select>
  );
};
